import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import { customStyles } from "../../../../Bookclosure/Components/AddTaskModal";
import commoncss from "../../../css/common.module.css";
import buttoncss from "../../../css/button.module.css";
import Modal from "../../../elements/Modal";
import { Button } from "../../../elements/Button";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/calender.svg";
import InputGroup from "../../../elements/InputGroup";
import bookclosure_taskstatus from "../../../data/bookclosure_taskstatus.json";
import modules from "../../../data/modules.json";
import FilterRow from "../../../components/loans/Listing/ListingfFilterRow";
import CustomDropdownIndicator from "../../../elements/CustomDropdownIndicator";
import { loansListing, UploadLoanFiles, GetLoanMapping, saveLoanMapping, GetSubLoanMapping, submapping } from '../../../../Bookclosure/Services/ApiHandler'

const ListingFilterModel = ({
  setListingFilterModel,
  handleClose,
  // companyId,
  // assignOptions,
  // approveOptions,
  // getBookClosureData,
  filterAttr,
  loanID,
  applyLoansListingFilter,
  filterOptions
}) => {
  const [module, setModule] = useState(null);
  const [assigneeId, setAssigneeId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [applicantName, setApplicantName] = useState(null);
  // const [customFilter, setCustomFilter] = useState(false);
  const [customFilter, setCustomFilter] = useState(true);
  const animatedComponents = makeAnimated();
  const [filterRows, setFilterRows] = useState([{}]);

  const addFilter = () => {
    setFilterRows((prev) => [...prev, {}]);
  };

  const updateFilterRow = (index, updated) => {
    setFilterRows((prev) => {
      return prev.map((row, i) => {
        if (i === index) {
          return typeof updated === "function"
            ? updated(row)
            : { ...row, ...updated };
        }
        return row;
      });
    });
  };

  
  const applyFilter = (filterType) => {
    const requestBody = {};
     if (filterType === "basicFilter") {
    // Add basic filters if they are selected
    if (customerId) requestBody.customerID = customerId.value;
    if (applicantName) requestBody.customerName = applicantName.value;
    if (module) requestBody.productID = module.value;
    if (assigneeId) requestBody.productName = assigneeId.value;
    if (approverId) requestBody.loanID = approverId.value;
      applyLoansListingFilter(requestBody);
     }
    if (filterType === "customFilter") {
        const filteredRows = filterRows.filter((row) => row.field && row.value);
        const customFilters = filteredRows.map(row => ({
           
           field: row.field,
           dataType: row.dataType,
           type: row.filterType,
           value: row.value,
        }));

        
        // Add the custom filters array to the request body
        if (customFilters.length > 0) {
            requestBody.filters = customFilters;
        }
          applyLoansListingFilter( requestBody);
    }
  }
  const removeFilterRow = (indexToRemove) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const clearAllFilters = () => {
    setFilterRows([]);
    // setListingFilterModel(false);
  };

  const clearBasicFilters = () => {
    setModule(null);
    setAssigneeId(null);
    setApproverId(null);
    setCustomerId(null);
    setApplicantName(null);
  };

  return (
    <Modal
      width={`${customFilter ? "45%" : "35%"}`}
      minHeight={"350px"}
      title="Filters"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          {!customFilter && (
            // <CloseIcon
            //   onClick={() => {
            //     setListingFilterModel(false);
            //   }}
            //   className="clickable"
            // />
            <label
              className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
              onClick={() => {
                clearBasicFilters();
              }}
            >
              Reset All
            </label>
          )}
          {customFilter && filterRows.length > 0 && (
            <label
              className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
              onClick={clearAllFilters}
            >
              Reset All
            </label>
          )}
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setListingFilterModel(false);
              handleClose();
            }}
            label="Cancel"
          />
          <span>
            {!customFilter && (
              <Button
                btnColor={buttoncss.secondary}
                label="Custom Filters"
                // onClick={setCustomFilter}
                onClick={() => setCustomFilter(true)} // Open the custom filter directly

              />
            )}
            {customFilter && (
              <Button
                btnColor={buttoncss.secondary}
                label="Add Filter"
                onClick={addFilter}
              />
            )}
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Apply Filter"
              onClick={() => {
                applyFilter(customFilter ? "customFilter" : "basicFilter");
                handleClose()
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        {!customFilter && (
          <>

            <InputGroup
              inputs={[
                <>
                  <span className="input-label">Customer ID</span>
                  <Select
                    placeholder="Select Ledger Code"
                    name="customerId"
                    value={customerId}
                    onChange={setCustomerId}
                    options={filterOptions.customerIDs.map(id => ({ value: id, label: id }))}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={customStyles}
                  />
                </>,
                <>
                  <span className="input-label">Customer Name</span>
                  <Select
                    placeholder="Select Ledger Name"
                    name="applicantName"
                    value={applicantName}
                    onChange={setApplicantName}
                    options={filterOptions.customerNames.map(id => ({ value: id, label: id }))}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={customStyles}
                  />
                </>,
              ]}
            />
            <span className="input-label mt-2">Product ID</span>

            <Select
              placeholder="Select Module"
              name="Product ID"
              value={module}
              onChange={setModule}
              options={filterOptions.productIDs.map(id => ({ value: id, label: id }))}
              className="w-100 mt-0"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

            <span className="input-label mt-2">Product Name</span>
            <Select
              placeholder="Select Assignee"
              name="Product Name"
              value={assigneeId}
              onChange={setAssigneeId}
              options={filterOptions.productNames.map(id => ({ value: id, label: id }))}
              className="w-100 mt-0"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

            <span className="input-label mt-2">Loan ID</span>
            <Select
              placeholder="Select Approver"
              name="Legacy ID"
              value={approverId}
              onChange={setApproverId}
              options={filterOptions.loanIDs.map(id => ({ value: id, label: id }))}
              className="w-100 mt-0 mb-2"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

          </>
        )}

        {customFilter && (
          <>
            {filterRows.map((_, index) => (
              <>
                <span className="input-label mt-1">&nbsp;Where</span>
                <div style={{ display: "flex", gap: "10px" }}>
                  <FilterRow
                    key={index}
                    onChange={(data) => updateFilterRow(index, data)}
                    filterAttr={filterAttr}
                    onRemove={() => removeFilterRow(index)}
                  />
                </div>
              </>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
};

export default ListingFilterModel;
